document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('details.accordion__details');

  accordions.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        accordions.forEach((other) => {
          if (other !== item) {
            other.removeAttribute('open');
          }
        });
      }
    });
  });
});
